module.exports = __webpack_public_path__ + "static/media/day-to-day.ba1b381f.jpg";